import React, { memo } from "react";
import { connect } from "react-redux";
import { Form, Input, InputNumber, Modal, Select, Button, Tabs, Checkbox, AutoComplete } from "antd";
import "antd/dist/antd.css";
import _ from "lodash";
import {
    routeCoordinateReverseLookup,
    getSessionsFromCoords,
    routeSelected,
    swapDashboard,
    refresh,
    findAudit,
    searchForTimestamp,
    whatThreeWordsLookup,
    getAutoCompleteValuesBySystemID,
    getMlAssetTypes,
    searchForInspectionPulse,
    setTargetInpectionTimestamp,
    lookupLatLon,
    receiveLocationSearchResults,
    customAudit,
    requestPlaylistTimestamp,
    setLocationSearchLoading,
    SESSION_FILTERS_DEFAULTS,
    setSessionDateFilter,
    setSessionTagFilter,
} from "../../redux/actions/index";
import OBCSpinner from "../util/OBC";
import { withRouter } from "react-router-dom";
import DashboardLogo from "../DashboardLogoComponent";
import FindAssetForm from "./FindAssetForm";
import FindStationForm from "./FindStationForm";
import RouteCoordinateSystems from "../util/RouteCoordinateSystems";
import { calculatePulseFromTimestamp } from "components/util/Geometry";
import SessionListFilterPill from "components/session/SessionListFilterPill";
import SessionsSearch from "components/session/SessionsSearch";
import { osgbToCoordinate } from "components/util/Geometry";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import LocationResultRow from "./LocationResultRow";
import { areEqual, FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import memoize from "memoize-one";

const { TabPane } = Tabs;
const { Option } = AutoComplete;

const SEARCH_ITEM_SIZE = 115;
const FindLocationForm = Form.create({
    name: "select_location",
    onFieldsChange(props, changedFields, allFields) {
        props.onChange(allFields);
    },
})(
    // eslint-disable-next-line
    class extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                selectedLocationType: props.defaultSystemString ? props.defaultSystemString : "lat/lon",
                filteredElrsList: [],
            };
        }

        selectLocationType = (selectedLocationType) => {
            this.setState({
                selectedLocationType,
            });
        };

        componentDidMount() {
            this.componentDidUpdate({}, {});
        }

        componentDidUpdate(prevProps, prevState, snapshot) {
            if (prevState.selectedLocationType !== this.state.selectedLocationType) {
                const { form } = this.props;
                form.validateFields((errors, values) => {});
            }
            if (this.props.visible !== prevProps.visible) {
                if (this.focusedInput) {
                    this.focusedInput.focus();
                }
            }
        }

        handleElrsSearch = (value, systemID) => {
            let filteredElrsList;
            if (!value) {
                filteredElrsList = [];
            } else {
                filteredElrsList = this.props.autoCompleteValues[systemID].filter((elr) => elr.toLowerCase().indexOf(value.toLowerCase()) > -1);
            }
            this.setState({ filteredElrsList });
        };

        getFieldErrors = (touched, errors) => {
            // occasionally the error might include multiple errors are populated including error about
            // filed being required, if this is the case we only want to display error that field is required
            if (touched && errors && errors.length && errors.length > 1) {
                let _errors = [];
                _.map(errors, (error) => {
                    if (error.includes("required")) {
                        _errors.push(error);
                    }
                });

                if (_errors.length > 1) {
                    return _.join(errors, ", ");
                } else {
                    return _errors[0];
                }
            }

            return _.join(touched && errors, ", ");
        };

        render() {
            const { form } = this.props;
            const { getFieldDecorator, isFieldTouched, getFieldError } = form;
            const formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 12 },
            };
            const locationSelectFields = [];

            if (this.state.selectedLocationType === "lat/lon") {
                // Latitude
                const latitudeFiledErrors = this.getFieldErrors(isFieldTouched("Latitude"), getFieldError("Latitude"));
                locationSelectFields.push(
                    <Form.Item
                        key={"latitude"}
                        label={"Latitude"}
                        validateStatus={latitudeFiledErrors ? "error" : ""}
                        help={latitudeFiledErrors || ""}
                        {...formItemLayout}>
                        {getFieldDecorator("Latitude", {
                            rules: [{ required: true, type: "number" }],
                            initialValue: this.props.values.Latitude,
                        })(
                            <InputNumber
                                id="latitude-input"
                                autoFocus
                                ref={(input) => {
                                    this.focusedInput = input;
                                }}
                                className="full-width"
                            />,
                        )}
                    </Form.Item>,
                );

                // Longitude
                const longitudeFiledErrors = this.getFieldErrors(isFieldTouched("Longitude"), getFieldError("Longitude"));
                locationSelectFields.push(
                    <Form.Item
                        key={"longitude"}
                        label={"Longitude"}
                        validateStatus={longitudeFiledErrors ? "error" : ""}
                        help={longitudeFiledErrors || ""}
                        {...formItemLayout}>
                        {getFieldDecorator("Longitude", {
                            rules: [{ required: true, type: "number" }],
                            initialValue: this.props.values.Longitude,
                        })(
                            <InputNumber
                                id="longitude-input"
                                className="full-width"
                            />,
                        )}
                    </Form.Item>,
                );
            } else if (this.state.selectedLocationType === "manualPulse") {
                const filedErrors = this.getFieldErrors(isFieldTouched("Pulse"), getFieldError("Pulse"));
                locationSelectFields.push(
                    <Form.Item
                        key={"pulse"}
                        label={"Pulse"}
                        validateStatus={filedErrors ? "error" : ""}
                        help={filedErrors || ""}
                        {...formItemLayout}>
                        {getFieldDecorator("Pulse", {
                            rules: [{ required: true, type: "number" }],
                            initialValue: "",
                        })(
                            <InputNumber
                                autoFocus
                                ref={(input) => {
                                    this.focusedInput = input;
                                }}
                                className="full-width"
                            />,
                        )}
                    </Form.Item>,
                );
            } else if (this.state.selectedLocationType === "what3words") {
                const filedErrors = this.getFieldErrors(isFieldTouched("Words"), getFieldError("Words"));
                locationSelectFields.push(
                    <Form.Item
                        key={"words"}
                        label={"Words"}
                        validateStatus={filedErrors ? "error" : ""}
                        help={filedErrors || ""}
                        {...formItemLayout}>
                        {getFieldDecorator("Words", {
                            rules: [{ required: true, type: "string" }],
                            initialValue: "",
                        })(
                            <Input
                                className="full-width"
                                autoFocus
                                ref={(input) => {
                                    this.focusedInput = input;
                                }}
                            />,
                        )}
                    </Form.Item>,
                );
            } else if (this.state.selectedLocationType === "east/north") {
                const eastingFiledErrors = this.getFieldErrors(isFieldTouched("Easting"), getFieldError("Easting"));
                locationSelectFields.push(
                    <Form.Item
                        key={"easting"}
                        label={"Easting"}
                        validateStatus={eastingFiledErrors ? "error" : ""}
                        help={eastingFiledErrors || ""}
                        {...formItemLayout}>
                        {getFieldDecorator("Easting", {
                            rules: [{ required: true, type: "number" }],
                            initialValue: undefined,
                        })(
                            <InputNumber
                                className="full-width"
                                autoFocus
                                ref={(input) => {
                                    this.focusedInput = input;
                                }}
                            />,
                        )}
                    </Form.Item>,
                );

                const northingFiledErrors = this.getFieldErrors(isFieldTouched("Northing"), getFieldError("Northing"));
                locationSelectFields.push(
                    <Form.Item
                        key={"northing"}
                        label={"Northing"}
                        validateStatus={northingFiledErrors ? "error" : ""}
                        help={northingFiledErrors || ""}
                        {...formItemLayout}>
                        {getFieldDecorator("Northing", {
                            rules: [{ required: true, type: "number" }],
                            initialValue: undefined,
                        })(
                            <InputNumber
                                className="full-width"
                                autoFocus
                                ref={(input) => {
                                    this.focusedInput = input;
                                }}
                            />,
                        )}
                    </Form.Item>,
                );
            } else {
                _.forEach(RouteCoordinateSystems, (system) => {
                    const includeSystem = this.props.supportedCoordinateSystems.includes(system.ID);
                    if (!includeSystem) {
                        return;
                    }
                    _.forEach(system.handlerClass.display_formats, (desc, name) => {
                        const key = `${system.ID}.${name}`;
                        if (this.state.selectedLocationType !== key) {
                            return;
                        }
                        _.forEach(system.handlerClass.fields(name), (field_name, idx) => {
                            const field_details = system.handlerClass.display_fields[field_name];
                            if (!field_details) {
                                return;
                            }
                            let InputType;
                            if (field_details.rules[0].type === "integer") {
                                InputType = InputNumber;
                            } else {
                                InputType = Input;
                            }
                            let input;
                            if (idx === 0) {
                                input = (
                                    <InputType
                                        className="full-width"
                                        autoFocus
                                        ref={(input) => {
                                            this.focusedInput = input;
                                        }}
                                    />
                                );
                            } else {
                                input = <InputType className="full-width" />;
                            }
                            if (field_name === "ELR" || field_name === "ROUTE" || field_name === "LCS" || field_name === "LINE") {
                                input = (
                                    <Select
                                        id="ElrRouteIdInput"
                                        ref={(input) => {
                                            this.focusedInput = input;
                                        }}
                                        style={{ width: "100%" }}
                                        placeholder={!this.props.autoCompleteValues[system.ID] ? "Loading..." : "Start typing"}
                                        onSearch={(value) => this.handleElrsSearch(value, system.ID)}
                                        showSearch
                                        autoFocus
                                        showArrow={false}
                                        notFoundContent={null}
                                        allowClear
                                        loading={!this.props.autoCompleteValues[system.ID]}
                                        disabled={!this.props.autoCompleteValues[system.ID]}>
                                        {this.state.filteredElrsList.map((elr) => (
                                            <Option key={elr}>{elr}</Option>
                                        ))}
                                    </Select>
                                );
                            }
                            let rules = _.cloneDeep(field_details.rules);
                            if (this.props.railInspection && field_name === "TRACK") {
                                rules[0]["required"] = true;
                            }
                            const filedErrors = this.getFieldErrors(isFieldTouched(field_name), getFieldError(field_name));
                            locationSelectFields.push(
                                <Form.Item
                                    key={field_name}
                                    label={field_details.name}
                                    validateStatus={filedErrors ? "error" : ""}
                                    help={filedErrors || ""}
                                    {...formItemLayout}>
                                    {getFieldDecorator(field_name, {
                                        rules: rules,
                                        initialValue: this.props.values[field_name],
                                    })(input)}
                                </Form.Item>,
                            );
                        });
                    });
                });
            }

            const select_options = [
                <Select.Option
                    key={"lat/lon"}
                    value="lat/lon">
                    Latitude/Longitude
                </Select.Option>,
                <Select.Option
                    key={"what3words"}
                    value="what3words">
                    what3words
                </Select.Option>,
                <Select.Option
                    key={"easting/northing"}
                    value="east/north">
                    Easting/Northing
                </Select.Option>,
            ];

            if (this.props.railInspection && !_.isEmpty(this.props.inspectionPulseCounts)) {
                select_options.push(
                    <Select.Option
                        key={"pulse"}
                        value="manualPulse">
                        Pulse Count
                    </Select.Option>,
                );
            }

            _.forEach(RouteCoordinateSystems, (system) => {
                const includeSystem = this.props.supportedCoordinateSystems.includes(system.ID);
                if (includeSystem) {
                    const sub_options = _.map(system.handlerClass.display_formats, (desc, name) => (
                        <Select.Option
                            id={`${name}-location-select-option`}
                            key={name}
                            value={`${system.ID}.${name}`}>
                            {desc}
                        </Select.Option>
                    ));
                    if (sub_options.length) {
                        select_options.push(
                            <Select.OptGroup
                                label={system.ID}
                                key={system.ID}>
                                {sub_options}
                            </Select.OptGroup>,
                        );
                    }
                }
            });

            return (
                <>
                    <Form
                        id="elrForm"
                        style={{ paddingTop: "5px" }}>
                        <Form.Item
                            label="Location Type"
                            {...formItemLayout}>
                            {getFieldDecorator("location_type", {
                                initialValue: this.state.selectedLocationType,
                                rules: [{ required: true }],
                            })(<Select onSelect={this.selectLocationType}>{select_options}</Select>)}
                        </Form.Item>
                        {locationSelectFields}
                    </Form>
                    <div className="SearchLocationFilters">
                        <div className="SearchLocationFiltersTitle">Search Options:</div>
                        <SessionsSearch
                            searchID="SearchLocation"
                            lightTheme={true}
                            tagsOnly={true}
                        />
                        <div className="SearchLocationFiltersPill">
                            <SessionListFilterPill
                                showText
                                showDivider={false}
                            />
                        </div>
                    </div>
                </>
            );
        }
    },
);

class FindLocationPopup extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fields: {
                location_type: "lat/lon",
                hasErrors: true,
            },
            findingLocation: false,
            noMatchesFound: false,
            searchAllDashboards: true,
            sessionsFound: [],
            workspaceCollapsedStatus: {},
            displaySessionList: false,
            coordinatesFound: [],
            loadingManualSearch: false,
            activeTab: "location",
            findStationDisabled: true,
            result_type: null,
            searchAcrossDashboards: false,
            sessionToSelect: null,
            dashboardListOpen: null,
            bypassWorkspaceFilter: false,
            autoSearchData: null,
        };

        this.stationTab = React.createRef();
    }

    componentDidMount() {
        this.componentDidUpdate({}, {});
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (_.isEmpty(prevProps.searchValues) && !_.isEmpty(this.props.searchValues) && this.props.searchValues.searchType) {
            this.handleAutoSearch();
        }

        if (!prevProps.visible && this.props.visible) {
            this.setState({
                activeTab: "location",
            });

            this.props.dispatch(getMlAssetTypes());

            this.props.dispatch(findAudit("open_find_dialog", {}));
            _.forEach(RouteCoordinateSystems, (system) => {
                const includeSystem = this.props.supportedCoordinateSystems.includes(system.ID);
                if (!includeSystem) {
                    return;
                }
                this.props.dispatch(getAutoCompleteValuesBySystemID(system.ID));
            });
        }

        if (!_.isEqual(prevProps.supportedCoordinateSystems, this.props.supportedCoordinateSystems)) {
            let defaultLocationType = "lat/lon";

            _.forEach(RouteCoordinateSystems, (system) => {
                if (defaultLocationType === "lat/lon") {
                    const includeSystem = this.props.supportedCoordinateSystems.includes(system.ID);
                    if (includeSystem) {
                        _.forEach(system.handlerClass.display_formats, (desc, name) => {
                            if (defaultLocationType === "lat/lon") {
                                defaultLocationType = `${system.ID}.${name}`;
                            }
                        });
                    }
                }
            });
            const newFields = _.clone(this.state.fields);
            newFields["location_type"] = defaultLocationType;
            this.setState({
                fields: newFields,
            });
        }

        if (!prevProps.currentDashboard && this.props.currentDashboard && this.state.sessionToSelect) {
            this.onSessionClick(this.state.sessionToSelect);
        }

        // if popup with search result displayed on the map and fitlers adjusted fetch new results to match new filters
        if (
            !_.isEqual(prevProps.sessionListFilters, this.props.sessionListFilters) &&
            !this.props.sessionListFilters.refreshing &&
            this.props.nearbyRouteCoordinates &&
            this.props.nearbyRouteCoordinates.length
        ) {
            this.props.dispatch(setLocationSearchLoading(true)); // this to help with user feedback that its loading data
            this.findLocation();
        }
    };

    sendFindAudit = () => {
        const url = this.props.searchValues.findLink;
        const auditText = `find_link_used by user ${this.props.userEmail}: ${url}`;
        this.props.dispatch(customAudit("find_link_used", this.props.searchValues, auditText));
    };

    handleAutoSearch = (overrideSearchData = null) => {
        let searchParams = {};
        this.sendFindAudit();

        if (this.props.searchValues.searchType === "location") {
            searchParams = {
                location_type: "lat/lon",
                Latitude: parseFloat(this.props.searchValues.paramOne),
                Longitude: parseFloat(this.props.searchValues.paramTwo),
            };
        } else if (this.props.searchValues.searchType === "timestamp") {
            searchParams = {
                location_type: "timestamp",
                timestamp: parseFloat(this.props.searchValues.paramOne),
                filters: this.props.searchValues.filterParams,
            };
        } else if (this.props.searchValues.searchType === "pulse") {
            searchParams = {
                location_type: "pulse",
                pulse: this.props.searchValues.paramOne,
                timestamp: this.props.searchValues.paramTwo,
                deviceGroup: this.props.searchValues.paramThree,
                filters: this.props.searchValues.filterParams,
            };
        } else {
            _.forEach(RouteCoordinateSystems, (system) => {
                if (this.props.searchValues.searchType === system.simpleName) {
                    const display_format = _.keys(system.handlerClass.display_formats)[0];
                    const key = `${system.ID}.${display_format}`;
                    searchParams = {
                        ...this.props.searchValues,
                        location_type: key,
                    };
                }
            });
        }

        if (overrideSearchData) {
            searchParams = overrideSearchData;
        }

        if (searchParams.location_type) {
            this.dismissLocationSearch();
            this.setState(
                {
                    loadingManualSearch: true,
                    searchAcrossDashboards: true,
                    autoSearchData: searchParams,
                },
                () => {
                    this.findLocation(searchParams);
                },
            );
        }
    };

    searchAcrossDashboardsChange = (e) => {
        this.setState({
            searchAcrossDashboards: e.target.checked,
        });
    };

    onFieldChanged = (changedFields) => {
        const relevantFields = _.chain(changedFields)
            .toPairs()
            .filter((value) => !value[1].dirty && !value[1].errors)
            .map((value) => [value[0], value[1].value])
            .fromPairs()
            .value();

        const fieldsWithErrors = _.chain(changedFields)
            .toPairs()
            .filter((value) => value[1].errors)
            .map((value) => value[0])
            .value();

        this.setState({
            hasErrors: fieldsWithErrors.length > 0,
            fields: { ...this.state.fields, ...relevantFields },
        });
    };

    dismissLocationSearch = () => {
        this.props.history.replace("", null);
    };

    injectSessionListFiltersTags = (newTags) => {
        this.props.dispatch(setSessionTagFilter(newTags));
    };

    injectSessionDateFilter = (start_ts, end_ts) => {
        const newDateFilter = {
            from: null,
            to: null,
        };

        if (start_ts != null) {
            newDateFilter.from = parseInt(start_ts);
        } else {
            // 2020/1/1 00:00:00 GMT (milliseconds)
            newDateFilter.from = 1577836800;
        }

        if (end_ts != null) {
            newDateFilter.to = parseInt(end_ts);
        } else {
            newDateFilter.to = Date.now() / 1000;
        }

        this.props.dispatch(setSessionDateFilter(newDateFilter));
    };

    /**
     * Helper to inject filters from search values into session filters
     */
    injectFiltersFromSearchValues = () => {
        if (_.get(this.props.searchValues, ["filterParams", "tags"], false)) {
            this.injectSessionListFiltersTags(_.split(this.props.searchValues.filterParams.tags, ","));
        }

        if (_.get(this.props.searchValues, ["filterParams", "start_ts"], false) || _.get(this.props.searchValues, ["filterParams", "end_ts"], false)) {
            this.injectSessionDateFilter(this.props.searchValues.filterParams.start_ts, this.props.searchValues.filterParams.end_ts);
        }
    };

    /**
     * Helper to create payload with optional filters from search values
     */
    createSearchPayload = (basePayload) => {
        const payload = { ...basePayload };

        const timestampFilter = _.get(this.props.searchValues, ["filterParams", "timestamp"], false);
        if (timestampFilter) {
            payload["timestamp"] = timestampFilter;
        }

        const deviceFilter = _.get(this.props.searchValues, ["filterParams", "deviceKey"], false);
        if (deviceFilter) {
            payload["device_key"] = deviceFilter;
        }

        const workspaceFilter = _.get(this.props.searchValues, ["filterParams", "workspace"]);
        if (workspaceFilter && !this.state.bypassWorkspaceFilter) {
            payload["workspace"] = workspaceFilter;
        } else if (this.state.bypassWorkspaceFilter) {
            payload["workspace"] = null;
        }

        return payload;
    };

    /**
     * Helper to handle autoplay logic for single session results
     */
    handleAutoplaySession = (sessions) => {
        if (sessions.length === 0) {
            return false;
        }

        const autoplay = _.get(this.props.searchValues, ["autoplay"], false);
        const targetInspection = _.get(this.props.searchValues, ["inspection"], false);

        if (targetInspection) {
            const firstInspectionSession = _.find(sessions, (s) => s.inspection);
            if (firstInspectionSession) {
                if (this.props.currentDashboard) {
                    this.onSessionClick(firstInspectionSession);
                } else {
                    this.setState({
                        sessionToSelect: firstInspectionSession,
                    });
                }
                return true;
            }
        }

        if (autoplay) {
            const firstSession = sessions[0];

            if (this.props.currentDashboard) {
                this.onSessionClick(firstSession);
            } else {
                this.setState({
                    sessionToSelect: firstSession,
                });
            }
        }

        return false;
    };

    /**
     * Helper to handle successful session search results
     */
    handleSuccessfulSessionSearch = (resultType, parsedCoordinates, sessions) => {
        if (this.handleAutoplaySession(sessions)) {
            return;
        }

        this.setState({
            result_type: resultType,
            coordinatesFound: parsedCoordinates,
            loadingManualSearch: false,
            sessionsFound: sessions,
            displaySessionList: true,
            findingLocation: false,
        });
    };

    /**
     * Helper to handle search errors
     */
    handleSearchError = () => {
        this.setState({
            noMatchesFound: true,
            loadingManualSearch: false,
            findingLocation: false,
        });
    };

    /**
     * Helper to handle non-dashboard search success
     */
    handleNonDashboardSearchSuccess = (resultType, parsedCoordinates) => {
        this.setState({
            findingLocation: false,
            loadingManualSearch: false,
        });
        this.props.dispatch(receiveLocationSearchResults(resultType, parsedCoordinates));
        this.props.onConfirm();
    };

    /**
     * Handle latitude/longitude search
     */
    handleLatLonSearch = (fields, manualParams, searchDashboards) => {
        const _this = this;
        let lat = fields.Latitude;
        if (manualParams.Latitude) {
            lat = manualParams.Latitude;
        }

        let lon = fields.Longitude;
        if (manualParams.Longitude) {
            lon = manualParams.Longitude;
        }

        console.log("lat, lon", lat, lon);
        this.props.dispatch(findAudit("find_location", { lat, lon, locationType: "lat/lon" }));

        this.props.dispatch(
            lookupLatLon(lat, lon, searchDashboards, (resultType, parsedCoordinates) => {
                if (parsedCoordinates) {
                    if (!searchDashboards) {
                        this.handleNonDashboardSearchSuccess(resultType, parsedCoordinates);
                    } else {
                        const payload = this.createSearchPayload({ lon, lat });
                        this.injectFiltersFromSearchValues();

                        this.props.dispatch(
                            getSessionsFromCoords(payload, function (sessions) {
                                console.log("FOUND SESSIONS", sessions, _this.props.searchValues);
                                _this.handleSuccessfulSessionSearch(resultType, parsedCoordinates, sessions);
                            }),
                        );
                    }
                } else {
                    this.handleSearchError();
                }
            }),
        );
    };

    /**
     * Handle what3words search
     */
    handleWhat3WordsSearch = (fields, searchDashboards) => {
        const _this = this;
        let words = fields.Words;

        if (words.includes(" ")) {
            words = words.replaceAll(" ", ".");
        } else if (words.includes("-")) {
            words = words.replaceAll("-", ".");
        }

        this.props.dispatch(
            whatThreeWordsLookup(words, !searchDashboards, (result_type, parsedCoordinates, location) => {
                if (parsedCoordinates) {
                    if (!searchDashboards) {
                        this.handleNonDashboardSearchSuccess("closest", parsedCoordinates);
                    } else {
                        const payload = this.createSearchPayload({
                            lat: location.lat,
                            lon: location.lon,
                        });
                        this.injectFiltersFromSearchValues();

                        this.props.dispatch(
                            getSessionsFromCoords(payload, function (sessions) {
                                console.log("FOUND SESSIONS", sessions);
                                _this.handleSuccessfulSessionSearch(result_type, parsedCoordinates, sessions);
                            }),
                        );
                    }
                } else {
                    this.handleSearchError();
                }
            }),
        );
    };

    /**
     * Handle easting/northing search
     */
    handleEastingNorthingSearch = (fields, searchDashboards) => {
        const _this = this;
        let eastingNorthing = [parseInt(fields.Easting), parseInt(fields.Northing)];
        const latLon = osgbToCoordinate(eastingNorthing);

        this.props.dispatch(
            lookupLatLon(latLon[0], latLon[1], searchDashboards, (resultType, parsedCoordinates) => {
                if (parsedCoordinates) {
                    if (!searchDashboards) {
                        this.handleNonDashboardSearchSuccess(resultType, parsedCoordinates);
                    } else {
                        const lon = latLon[1];
                        const lat = latLon[0];

                        const payload = this.createSearchPayload({ lon, lat });
                        this.injectFiltersFromSearchValues();

                        this.props.dispatch(
                            getSessionsFromCoords(payload, function (sessions) {
                                console.log("FOUND SESSIONS", sessions, _this.props.searchValues);
                                _this.handleSuccessfulSessionSearch(resultType, parsedCoordinates, sessions);
                            }),
                        );
                    }
                } else {
                    this.handleSearchError();
                }
            }),
        );
    };

    /**
     * Handle timestamp search
     */
    handleTimestampSearch = (manualParams) => {
        const _this = this;

        if (this.state.bypassWorkspaceFilter) {
            _.set(manualParams, ["filters", "workspace"], null);
        }
        this.props.dispatch(
            searchForTimestamp(manualParams.timestamp, manualParams.filters, (resultType, sessions) => {
                if (sessions) {
                    _this.handleSuccessfulSessionSearch(resultType, null, sessions);
                } else {
                    this.handleSearchError();
                }
            }),
        );
    };

    /**
     * Handle pulse search
     */
    handlePulseSearch = (manualParams) => {
        const _this = this;
        this.props.dispatch(
            searchForInspectionPulse(manualParams.pulse, manualParams.timestamp, manualParams.deviceGroup, manualParams.filters, (response) => {
                if (response.image_timestamp && response.session_id) {
                    if (response.workspace_id !== this.props.currentDashboard.access_id) {
                        const dashboard = _.find(this.props.dashboards, (dash) => dash.access_id === parseInt(response.workspace_id));
                        this.props.dispatch(swapDashboard(dashboard.access_token));
                    }

                    if (!_.isNil(response.target_interpolation_distance)) {
                        this.props.dispatch(setTargetInpectionTimestamp(response.image_timestamp, response.target_interpolation_distance));
                    }
                    this.onModalClose();
                    this.props.dispatch(
                        refresh(() => {
                            _this.props.dispatch(routeSelected(response.session_id, parseInt(response.image_timestamp), undefined, _this.props.isStills));
                        }),
                    );
                } else {
                    this.setState({
                        noMatchesFound: true,
                        loadingManualSearch: false,
                        findingLocation: false,
                    });
                }
            }),
        );
    };

    /**
     * Handle manual pulse search
     */
    handleManualPulseSearch = (fields) => {
        const { timestamp } = calculatePulseFromTimestamp(fields.Pulse, this.props.inspectionPulseCounts);
        if (timestamp) {
            this.props.dispatch(requestPlaylistTimestamp(timestamp / 1000));
        }
        this.setState({
            loadingManualSearch: false,
            findingLocation: false,
        });
    };

    /**
     * Handle route coordinate system search
     */
    handleRouteCoordinateSearch = (fields, manualParams, locationType, searchDashboards) => {
        const _this = this;
        let found = false;

        _.forEach(RouteCoordinateSystems, (system) => {
            _.forEach(system.handlerClass.display_formats, (desc, name) => {
                const key = `${system.ID}.${name}`;
                if (locationType !== key) {
                    return;
                }

                let route_coordinate;
                if (manualParams.location_type === locationType) {
                    route_coordinate = system.from_search(manualParams);
                    _.forEach(fields, (field, name) => {
                        fields[name] = route_coordinate.field_value(name, this.props.datum_offsets);
                    });
                } else {
                    route_coordinate = system.from_fields(name, fields, this.props.datum_offsets);
                }
                found = true;

                this.props.dispatch(
                    findAudit("find_location", {
                        route: route_coordinate.route,
                        position: route_coordinate.position,
                        subposition: route_coordinate.subposition,
                        locationType: system.ID,
                    }),
                );

                _this.findInterpolatedLocation(system.ID, route_coordinate.route, route_coordinate.position, route_coordinate.subposition, searchDashboards);
            });
        });

        if (!found) {
            this.setState({
                noMatchesFound: true,
                loadingManualSearch: false,
                findingLocation: false,
            });
        }
    };

    findLocation = (manualParams = {}) => {
        const searchDashboards = this.state.searchAcrossDashboards;
        const fields = this.state.fields;
        let locationType = fields.location_type;

        if (manualParams.location_type) {
            locationType = manualParams.location_type;
        }

        this.setState({
            findingLocation: true,
            noMatchesFound: false,
        });

        if (locationType === "lat/lon") {
            this.handleLatLonSearch(fields, manualParams, searchDashboards);
        } else if (locationType === "what3words") {
            this.handleWhat3WordsSearch(fields, searchDashboards);
        } else if (locationType === "east/north") {
            this.handleEastingNorthingSearch(fields, searchDashboards);
        } else if (locationType === "timestamp") {
            this.handleTimestampSearch(manualParams);
        } else if (locationType === "pulse") {
            this.handlePulseSearch(manualParams);
        } else if (locationType === "manualPulse") {
            this.handleManualPulseSearch(fields);
        } else {
            this.handleRouteCoordinateSearch(fields, manualParams, locationType, searchDashboards);
        }
    };

    onCheckboxToggle = (e) => {
        this.setState({
            searchAllDashboards: e.target.checked,
        });
    };

    renderSessionList = memoize((selectedDashboard, sessionsFound) => {
        const _this = this;

        if (!sessionsFound.length) {
            if (_.get(this.props.searchValues, ["filterParams", "workspace"])) {
                return (
                    <p
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={() => {
                            this.setState({ bypassWorkspaceFilter: true, displaySessionList: false }, () => {
                                this.handleAutoSearch(this.state.autoSearchData);
                            });
                        }}
                        className="Error"
                        rel="noopener noreferrer">
                        No sessions found within the selected workspace - Click here to search across all of your workspaces
                    </p>
                );
            } else if (this.props.sessionListFiltersActive) {
                return <span style={{ color: "red" }}>No Sessions Found - Please review your session list filters and try again.</span>;
            } else {
                return (
                    <a
                        href={this.footageRequestLink()}
                        className="Error"
                        style={{ color: "red" }}
                        target="_blank"
                        rel="noopener noreferrer">
                        No Sessions Found - Click here to enquire about data collection options
                    </a>
                );
            }
        }

        if (!_this.props.currentDashboard) {
            return null;
        }
        let groupedSessions = _.groupBy(sessionsFound, "workspace_id");

        let dashboardKeys = Object.keys(groupedSessions);
        dashboardKeys.sort(function (x, y) {
            return x === _this.props.currentDashboard.access_id ? -1 : y === _this.props.currentDashboard.access_id ? 1 : 0;
        });

        if (selectedDashboard) {
            let orderedSessions = groupedSessions[selectedDashboard];
            let timestampToFind = 0;

            if (_.get(this.props.searchValues, ["filterParams", "timestamp"], false)) {
                timestampToFind = this.props.searchValues.filterParams.timestamp;
                if (timestampToFind < 9999999999) {
                    timestampToFind *= 1000;
                }

                orderedSessions = orderedSessions.sort((a, b) => Math.abs(a.timestamp - timestampToFind) - Math.abs(b.timestamp - timestampToFind));
            } else {
                orderedSessions = _.orderBy(groupedSessions[selectedDashboard], "session_id", "desc");
            }

            const Row = memo(({ index, style }) => {
                const session = orderedSessions[index];
                const isHighlighted = timestampToFind / 1000 > session.session_start && timestampToFind / 1000 < session.session_end;

                return (
                    <LocationResultRow
                        key={session.session_id}
                        session={session}
                        isHighlighted={isHighlighted}
                        onSessionClick={this.onSessionClick}
                        style={style}
                    />
                );
            }, areEqual);

            return (
                <div className={"searchSessionListWrapper"}>
                    <div
                        className="BackContainer"
                        onClick={() => this.setState({ dashboardListOpen: null })}>
                        <FontAwesomeIcon
                            icon={faChevronLeft}
                            className="BackIcon"
                        />

                        <p>All results</p>
                    </div>
                    <div className="AutosizeContainer">
                        <AutoSizer>
                            {({ height, width }) => {
                                return (
                                    <FixedSizeList
                                        key={orderedSessions.length}
                                        height={height}
                                        width={width}
                                        style={{ paddingBottom: 10, padding: "0 5px" }}
                                        itemSize={SEARCH_ITEM_SIZE}
                                        itemCount={orderedSessions.length}>
                                        {Row}
                                    </FixedSizeList>
                                );
                            }}
                        </AutoSizer>
                    </div>
                </div>
            );
        }

        return dashboardKeys.map((dashboardKey) => {
            let currentDashboard = false;
            let dashboardData = _.find(this.props.dashboards, (dash) => dash.access_id.toString() === dashboardKey);
            if (!dashboardData) {
                dashboardData = {
                    description: "Unknown dashboard",
                    unknown: true,
                };
            }

            if (this.props.currentDashboard && dashboardData.access_id === this.props.currentDashboard.access_id) {
                currentDashboard = true;
            }

            let orderedSessions = groupedSessions[dashboardKey];

            let timestampToFind = 0;

            if (_.get(this.props.searchValues, ["filterParams", "timestamp"], false)) {
                timestampToFind = this.props.searchValues.filterParams.timestamp;
                if (timestampToFind < 9999999999) {
                    timestampToFind *= 1000;
                }

                orderedSessions = orderedSessions.sort((a, b) => Math.abs(a.timestamp - timestampToFind) - Math.abs(b.timestamp - timestampToFind));
            } else {
                orderedSessions = _.orderBy(groupedSessions[dashboardKey], "session_id", "desc");
            }

            return (
                <div className="sessionGroupWrapper">
                    <div className="finderDashboardHeaderWrapper">
                        <div
                            className="finderDashboardHeader"
                            onClick={() => {
                                if (selectedDashboard === dashboardKey) {
                                    this.setState({ dashboardListOpen: null });
                                } else {
                                    this.setState({ dashboardListOpen: dashboardKey });
                                }
                            }}>
                            <div className="finderDashboardTitle">
                                <DashboardLogo
                                    dashboard={dashboardData}
                                    customStyles={{ margin: 0, marginRight: 10 }}
                                />
                                <p className="sessionDashboardHeaderTitle">{dashboardData.description + (currentDashboard ? " (Current dashboard)" : "")}</p>
                            </div>
                            <div>
                                <button
                                    id={dashboardKey + "CollapseButton"}
                                    className="finderDashboardCollapseButton">
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                        <span className="finderSessionCount">{orderedSessions.length} Sessions found</span>
                    </div>
                </div>
            );
        });
    });

    onSessionClick = (session) => {
        const targetInspection = _.get(this.props.searchValues, ["inspection"], false) && session.inspection;
        const timestamp = _.get(session, ["timestamp"], null);

        if (session.workspace_id === this.props.currentDashboard.access_id && targetInspection) {
            window.location.href = `/rail-inspection/${session.session_id}/${timestamp}`;
            return;
        }

        const sessionWorkspace = parseInt(session.workspace_id);
        if (sessionWorkspace !== this.props.currentDashboard.access_id) {
            const dashboard = _.find(this.props.dashboards, (dash) => dash.access_id === sessionWorkspace);
            this.props.dispatch(swapDashboard(dashboard.access_token));
            this.props.dispatch(
                refresh(() => {
                    this.props.dispatch(
                        routeSelected(
                            session.session_id,
                            session.timestamp,
                            undefined,
                            this.props.isStills,
                            session.stream_index,
                            session.video_frame,
                            false,
                            false,
                            null,
                            null,
                            true,
                            targetInspection,
                        ),
                    );
                }),
            );
        } else {
            this.props.dispatch(
                routeSelected(
                    session.session_id,
                    session.timestamp,
                    undefined,
                    this.props.isStills,
                    session.stream_index,
                    session.video_frame,
                    false,
                    false,
                    null,
                    null,
                    true,
                    targetInspection,
                ),
            );
        }

        // this.props.dispatch(goToBounds(localSession.bounds));
        this.onModalClose();
    };

    onModalClose = () => {
        this.setState({
            searchAllDashboards: true,
            bypassWorkspaceFilter: false,
            sessionsFound: [],
            displaySessionList: false,
            loadingManualSearch: false,
            findingLocation: false,
            fields: {
                location_type: "lat/lon",
                hasErrors: true,
            },
        });
        this.props.onCancel();
    };

    renderFooter = () => {
        if (this.state.activeTab === "location") {
            if (this.state.loadingManualSearch) {
                return [];
            } else if (this.props.railInspection) {
                let footer = [
                    <Button
                        onClick={this.props.onCancel}
                        key="cancel">
                        Close
                    </Button>,
                    <Button
                        loading={this.state.findingLocation}
                        onClick={this.findLocation}
                        key="findMap"
                        type="primary"
                        disabled={this.state.hasErrors}
                        htmlType="submit"
                        form="elrForm">
                        Search
                    </Button>,
                ];
                return footer;
            } else if (!this.state.displaySessionList) {
                if (this.props.dashboards.length > 1) {
                    return [
                        <Checkbox
                            checked={this.state.searchAcrossDashboards}
                            onChange={this.searchAcrossDashboardsChange}
                            style={{ marginRight: 10 }}>
                            Search across all workspaces
                        </Checkbox>,
                        <Button
                            id="find-location-button"
                            loading={this.state.findingLocation}
                            onClick={this.findLocation}
                            key="findSessions"
                            type="primary"
                            disabled={this.state.hasErrors}
                            htmlType="submit"
                            form="elrForm">
                            Find
                        </Button>,
                    ];
                } else {
                    return [
                        <Button
                            id="find-location-button-single"
                            loading={this.state.findingLocation}
                            onClick={this.findLocation}
                            key="findSessions"
                            type="primary"
                            disabled={this.state.hasErrors}
                            htmlType="submit"
                            form="elrForm">
                            Find
                        </Button>,
                    ];
                }
            } else {
                return [
                    <Button
                        onClick={this.backToSearch}
                        key="back">
                        Back
                    </Button>,
                    <Button
                        onClick={this.onModalClose}
                        key="cancel">
                        Close
                    </Button>,
                ];
            }
        } else if (this.state.activeTab === "assets") {
            return [
                <Button
                    onClick={this.onModalClose}
                    key="cancel">
                    Close
                </Button>,
            ];
        } else if (this.state.activeTab === "stations") {
            return [
                <Button
                    onClick={this.onModalClose}
                    key="cancel">
                    Close
                </Button>,
                <Button
                    onClick={this.findStation}
                    key="search"
                    type="primary"
                    disabled={this.state.findStationDisabled}>
                    Find
                </Button>,
            ];
        }
    };

    findStationDisabledToggle = (value) => {
        this.setState({
            findStationDisabled: value,
        });
    };

    findStation = () => {
        this.stationTab.current.findStation();
    };

    backToSearch = () => {
        // if back button pressed and autoCompleteValues is empty getAutoCompleteValues
        // itswill get triggered when user used find link and then press back button
        //
        if (this.state.dashboardListOpen) {
            this.setState({ dashboardListOpen: null });
            return;
        }

        if (_.isEmpty(this.props.autoCompleteValues)) {
            _.forEach(RouteCoordinateSystems, (system) => {
                const includeSystem = this.props.supportedCoordinateSystems.includes(system.ID);
                if (!includeSystem) {
                    return;
                }
                this.props.dispatch(getAutoCompleteValuesBySystemID(system.ID));
            });
        }
        this.setState({
            searchAllDashboards: true,
            sessionsFound: [],
            displaySessionList: false,
        });
    };

    findInterpolatedLocation = (system, route, position, subposition, searchDashboards = false) => {
        const _this = this;

        this.props.dispatch(
            routeCoordinateReverseLookup(system, route, position, subposition, !searchDashboards, (result_type, parsedCoordinates) => {
                if (parsedCoordinates) {
                    if (!searchDashboards) {
                        this.handleNonDashboardSearchSuccess(result_type, parsedCoordinates);
                    } else {
                        const payload = this.createSearchPayload({
                            system: system,
                            route: route,
                            position: position,
                            subposition: subposition,
                        });
                        this.injectFiltersFromSearchValues();

                        _this.props.dispatch(
                            getSessionsFromCoords(payload, function (sessions) {
                                _this.handleSuccessfulSessionSearch(result_type, parsedCoordinates, sessions);
                            }),
                        );
                    }
                } else {
                    this.handleSearchError();
                }
            }),
        );
    };

    onTabChange = (tab) => {
        this.setState({
            activeTab: tab,
        });
    };

    footageRequestLink = () => {
        let locationString = "";
        if (this.state.fields.location_type === "lat/lon") {
            locationString = `(${this.state.fields.Latitude},${this.state.fields.Longitude})`;
        } else if (this.state.fields.location_type === "ELR Mile & Chain.elr_mile_chain") {
            locationString = `${this.state.fields.ELR} ${this.state.fields.MILE} ${this.state.fields.CHAIN}`;
        } else if (this.state.fields.location_type === "ELR Mile & Chain.elr_meterage") {
            locationString = `${this.state.fields.ELR} ${this.state.fields.METERAGE}m`;
        } else if (this.state.fields.location_type === "ELR Mile & Chain.elr_mile_yards") {
            locationString = `${this.state.fields.ELR} ${this.state.fields.MILE} ${this.state.fields.YARDS}y`;
        }

        const link = `mailto:support@onebigcircle.co.uk?subject=Coverage Enquiry&body=Location : ${locationString}%0D%0AWorkspace Name - ${encodeURIComponent(_.get(this.props.currentDashboard, ["description"], ""))}`;
        return link;
    };

    render() {
        let content = (
            <>
                <FindLocationForm
                    dispatch={this.props.dispatch}
                    autoCompleteValues={this.props.autoCompleteValues}
                    onChange={this.onFieldChanged}
                    visible={this.props.visible}
                    supportedCoordinateSystems={this.props.supportedCoordinateSystems}
                    values={this.state.fields}
                    defaultSystemString={this.props.defaultSystemString}
                    railInspection={this.props.railInspection}
                    inspectionPulseCounts={this.props.inspectionPulseCounts}
                />
                {this.state.noMatchesFound && (
                    <a
                        href={this.footageRequestLink()}
                        className="Error"
                        style={{ color: "red" }}
                        // eslint-disable-next-line
                        target="_blank">
                        Location Not Found - Click here to enquire about data collection options
                    </a>
                )}
            </>
        );

        if (this.state.loadingManualSearch) {
            content = (
                <div className="locationSearchSpinnerDiv">
                    <OBCSpinner
                        size={150}
                        speed={3}
                        color={"#e8dfff"}
                    />
                </div>
            );
        }

        if (this.state.displaySessionList) {
            let coordinate = false;
            let coordinateInfo = false;

            if (this.state.coordinatesFound) {
                coordinate = this.state.coordinatesFound[0];
            }

            let locationDescription = "Unknown";

            if (coordinate) {
                if (coordinate.system === "Latitude/Longitude") {
                    locationDescription = "";
                } else {
                    const system = _.find(
                        RouteCoordinateSystems,
                        (system) => coordinate.system === system.ID && this.props.supportedCoordinateSystems.includes(system.ID),
                    );
                    if (system) {
                        const route_coordinate = system.create(coordinate.route, coordinate.position, coordinate.subposition);
                        locationDescription = route_coordinate.to_string(this.props.elrUnits, this.props.datum_offsets);
                    }
                }

                coordinateInfo = (
                    <div className={"RouteLocationInfoModal"}>
                        <div className="finderModalRouteLocationWrapper">
                            <div className="finderModalRouteLocation">
                                <div className="finderModalLocationLabel">{coordinate.system}</div>
                                <div className="finderModalLocation">{locationDescription}</div>
                            </div>
                            <div>
                                <div className="finderModalLocationLabel">Coordinates</div>
                                <div className={"RouteLocationOrigin"}>
                                    {coordinate.lat.toFixed(6)}, {coordinate.lon.toFixed(6)}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            content = (
                <div className="finderModal">
                    {coordinateInfo}
                    {this.renderSessionList(this.state.dashboardListOpen, this.state.sessionsFound)}
                </div>
            );
        }

        return (
            <Modal
                wrapProps={{ id: "find-location-modal" }}
                className="SearchLocationModal"
                bodyStyle={{ maxHeight: "75vh", overflow: "hidden", padding: "24px 24px 0 24px" }}
                visible={this.props.visible}
                onCancel={this.onModalClose}
                onOk={this.findLocation}
                footer={this.renderFooter()}
                keyboard={false}
                destroyOnClose={true}
                style={{ width: "50%" }}>
                <Tabs
                    defaultActiveKey="location"
                    onChange={this.onTabChange}>
                    <TabPane
                        tab="Find Location"
                        key="location"
                        className="findTabs"
                        style={{ color: "black" }}>
                        {content}
                    </TabPane>
                    {!this.props.railInspection && (
                        <TabPane
                            tab="Assets"
                            key="assets"
                            className="findTabs"
                            style={{ color: "black" }}>
                            <FindAssetForm closeModal={this.onModalClose} />
                        </TabPane>
                    )}
                    {!this.props.railInspection && (
                        <TabPane
                            tab="Stations"
                            key="stations"
                            className="findTabs"
                            style={{ color: "black" }}>
                            <FindStationForm
                                closeModal={this.onModalClose}
                                ref={this.stationTab}
                                findStationDisabled={this.findStationDisabledToggle}
                            />
                        </TabPane>
                    )}
                </Tabs>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    const sourceIndex = state.playlist.position.sourceIndex;

    const dashboardID = state.userDetails.dashboardAccessID;
    const currentDashboard = _.find(state.dashboards, (dash) => dash.access_id === dashboardID);
    const userViewOffsets = _.get(state.views, [state.userDetails.userConfig.view_id, "datum_offsets"], []);
    const workspaceViewOffsets = _.get(state.views, [_.get(currentDashboard, ["config", "view_id"], -1), "datum_offsets"], []);
    const datumOffsets = workspaceViewOffsets.length ? workspaceViewOffsets : userViewOffsets;
    const autoCompleteValues = state.searchLocationData.autoCompleteValues;

    let routePositionUnits = _.get(state, ["userDetails", "userConfig", "elr_units"], "elr_mile_chain");
    const supportedCoordinateSystems = state.routeCoordinateSystems;

    let selectedSystem = _.find(RouteCoordinateSystems, (system) => {
        return supportedCoordinateSystems.includes(system.ID) && system.handlerClass.display_formats[routePositionUnits];
    });
    let defaultSystemString = "";

    if (!selectedSystem) {
        const supportedSystems = RouteCoordinateSystems.filter((system) => {
            return supportedCoordinateSystems.includes(system.ID);
        });
        if (supportedSystems.length) {
            selectedSystem = supportedSystems[0];
            routePositionUnits = Object.keys(supportedSystems[0].handlerClass.display_formats);
            defaultSystemString = `${selectedSystem.ID}.${routePositionUnits}`;
        }
    } else {
        defaultSystemString = `${selectedSystem.ID}.${routePositionUnits}`;
    }
    const sessionListFilters = state.sessionListFilters;
    const sessionListFiltersActive = !sessionListFilters.refreshing && !_.isEqual(sessionListFilters, SESSION_FILTERS_DEFAULTS);

    return {
        currentDashboard: _.find(state.dashboards, (dash) => dash.access_token === state.access_token),
        supportedCoordinateSystems: state.routeCoordinateSystems,
        sessions: state.sessions,
        dashboards: state.dashboards || [],
        video: _.get(state.playlist.data, ["video", sourceIndex], []),
        elrUnits: _.get(state, ["userDetails", "userConfig", "elr_units"], "elr_mile_chain"),
        routePositionUnits,
        selectedSystem,
        defaultSystemString,
        datum_offsets: datumOffsets,
        isStills: state.playlist.position.isStills,
        autoCompleteValues,
        userEmail: _.get(state.userDetails, "email", "unknown email"),
        inspectionPulseCounts: state.railInspection.railInspectionPulseData,
        nearbyRouteCoordinates: state.locationSearch.results,
        sessionListFilters,
        sessionListFiltersActive,
        csrfToken: state.csrfToken,
    };
};

export default connect(mapStateToProps)(withRouter(FindLocationPopup));
